import { flow, Instance, types } from 'mobx-state-tree';
import { User } from '../model/user';
import { YoUser } from '@yakoffice/yakoffice-firebase';
import { PortalApiGateway } from '../apiGateway/PortalApiGateway';
import { MapToUserModel } from './mappers/map-user';

export const UsersStore = types.model(
    'UsersStore',
    {
        apiGateway: PortalApiGateway,
        users: types.array(User)
    })
    .actions(self => ({
        addUser() {
            const user = User.create({ isNew: true, projects: [] });
            self.users.replace([user]);
        },
        loadUsers: flow(function* () {
            try {
                const requestedUsers: YoUser[] = yield self.apiGateway.getUsers();
                const users = requestedUsers.map(user => User.create(MapToUserModel(user)));
                self.users.replace(users);
            } catch (e: any) {
                throw new Error(`Failed to load users: ${e.message}`);
            }
        }),
        loadUsersForProject: flow(function* (projectId: string) {
            try {
                const requestedUsers: YoUser[] = yield self.apiGateway.getUsersForProject(projectId);
                const users = requestedUsers.map(user => User.create(MapToUserModel(user)));
                self.users.replace(users);
            } catch (e: any) {
                throw new Error(`Failed to load users for project ${projectId}: ${e.message}`);
            }
        })
    }));

export interface IUsersStore extends Instance<typeof UsersStore> {
}
